import getWithToken from './base/get-with-token'

const getTaxonomyWaterUsage = id => getWithToken(`/customer-taxonomy/${id}/water-usage`)

export default getTaxonomyWaterUsage
